import { css, SerializedStyles } from '@emotion/core';
import { Theme, titleText, normalText } from 'features/Theme';

const style = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  headingText: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
  `,
  subHeadingContainer: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(1)}px;
  `,
  emphasizedText: (theme: Theme): SerializedStyles => css`
    ${theme.mui.typography.body1}
    font-weight: ${theme.mui.typography.fontWeightBold};
    color: ${theme.mui.palette.text.primary};
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  fieldContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  enquiryIcon: (theme: Theme): SerializedStyles => css`
    vertical-align: bottom;
    color: ${theme.mui.palette.primary.main};
    .MuiSvgIcon-root {
      vertical-align: bottom;
      padding: 14.5px;
      margin: -10px;
    }
  `,
};

export default style;
